import fetch from '../utils/http';



/**
 * 区域查询
 * 
 * @params { Object } params 参数集
 */
export function areaList(params) {
    const data = Object.assign({}, {}, params);
    return fetch.get({
      url: "/cgcp/general/api/areaList",
      data
    })
}


/**
 * 南昌市/青山湖区 企业消费帮扶光荣榜
 * 
 * @params { Object } params 参数集
 */
 export function queryPageByCust(params) {
    const data = Object.assign({}, {}, params);
    return fetch.post({
      url: "/magic/reportordercust/queryPageByCust",
      data
    })
}


/**
 * 参与帮扶单位数 和 帮扶消费销售额(万元)
 * 
 * @params { Object } params 参数集
 */
 export function totalByCust(params) {
    const data = Object.assign({}, {}, params);
    return fetch.post({
      url: "/magic/reportordercust/totalByCust",
      data
    })
}


/**
 * 区县排行榜
 * 
 * @params { Object } params 参数集
 */
 export function queryPageByRegion(params) {
  const data = Object.assign({}, {}, params);
  return fetch.post({
    url: "/magic/reportorderregion/queryPageByRegion",
    data
  })
}

/**
 * 单位查询结果
 * 
 * @params { Object } params 参数集
 */
 export function queryOrderInfo(params) {
  const data = Object.assign({}, {}, params);
  return fetch.get({
    url: "/cgcp/order/api/queryOrderInfo",
    data
  })
}

/**
 * （实时播报）
 * 
 * @params { Object } params 参数集
 */
 export function queryRealOrderInfo(params) {
  const data = Object.assign({}, {}, params);
  return fetch.post({
    url: "/cgcp/order/api/queryRealOrderInfo",
    data
  })
}